import { useDispatch, useSelector } from "react-redux";
import style from "./Filter.module.css";
import { setFilterValues } from "../../../../../Redux/Actions/VideoLibraryFilterAction";
import { filterVideoLibraryDataTable } from "../../../../../Redux/Actions/VideoLibraryDataTableActions";
import FilterAccordion from "./FilterAccordion";
import { useState } from "react";
import AddToQuickFilter from "./AddToQuickFilter";

const CurrentFilter = () => {
  const dispatch = useDispatch();
  const { appliedFilterList, filterValues } = useSelector(
    (state) => state?.videoLibraryFilterData
  );
  const { tableData } = useSelector((state) => state?.VideoLibraryDataTable);
  const [currentFilterList, setCurrentFilterList] = useState([]);
  const [isAddToQuickFilter, setIsAddToQuickFilter] = useState(false);
  const handleRemoveFilter = (filterData) => {
    // setAppliedFilterList(
    //   dispatch,
    //   appliedFilterList?.filter((item) => item?.id !== filterData?.id)
    // );
    setCurrentFilterList(
      currentFilterList.filter((item) => {
        return item?.id !== filterData.id;
      })
    );
    filterVideoLibraryDataTable(dispatch, {
      filterConditions: appliedFilterList?.filter(
        (item) => item?.id !== filterData?.id
      ),
      tableData: tableData,
    });
    setFilterValues(
      dispatch,
      filterValues?.filter((el) => el.id !== filterData.id)
    );
    // if (appliedFilterList.length === 1) {
    //   filterVideoLibraryDataTable(dispatch, []);
    //   setFilterValues(dispatch, []);
    // }
  };

  const handleRemoveFilterValue = (filterValue) => {
    setFilterValues(
      dispatch,
      filterValues?.filter((el) => el.value !== filterValue)
    );
  };

  const handleAddNewFilter = () => {
    const item = { filterName: "New Criteria", id: Date.now() };
    setCurrentFilterList((prevList) => [...prevList, item]);
  };

  const handleAddToQuickFilter = () => {
    setIsAddToQuickFilter(true);
  };

  return (
    <div className={style.maincontainerTooltip}>
      <div className={style.fiterTooltipContentContainer}>
        <ul className={` list-unstyled ${style.appliedFilterList}`}>
          {currentFilterList?.map((filter, index) => (
            <FilterAccordion
              key={index}
              className={`text-dark ${style.appliedFilterListItem}`}
              filter={filter}
              handleRemoveFilter={handleRemoveFilter}
              handleRemoveFilterValue={handleRemoveFilterValue}
              setCurrentFilterList={setCurrentFilterList}
              currentFilterList={currentFilterList}
            />
          ))}
        </ul>
      </div>
      <div className={`${style.filterContentFooterButtonContainer}`}>
        <button className="small-btn" onClick={handleAddNewFilter}>
          Add New Filter
        </button>
        <button
          disabled={currentFilterList.length == 0}
          className="small-btn "
          onClick={handleAddToQuickFilter}
        >
          Add To Quick Filter
        </button>
      </div>
      <AddToQuickFilter
        isAddToQuickFilter={isAddToQuickFilter}
        setIsAddToQuickFilter={setIsAddToQuickFilter}
        currentFilterList={currentFilterList}
        setCurrentFilterList={setCurrentFilterList}
      />
    </div>
  );
};

export default CurrentFilter;
